import React, { useEffect, useState } from 'react'
import './widget.scss'
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined'; 
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import OutletIcon from '@mui/icons-material/Outlet';
import GroupsIcon from '@mui/icons-material/Groups';
import InterestsIcon from '@mui/icons-material/Interests';
import PeopleIcon from '@mui/icons-material/People';
import { collection, where, query, getDocs, onSnapshot, getAggregateFromServer, sum } from 'firebase/firestore'
import { db } from '../../firebase'
import { Link } from "react-router-dom";

const Widget= ({type}) => {

  const [users, setUsers] = useState(null)
  const [subscribers, setSubscribers] = useState(null)
  const [outlets, setOutlets] = useState(null)
  const [adverts, setAdverts] = useState(null)
  const [earnings, setEarnings] = useState(null)
  const [diff, setDiff] = useState(null);
  const [datas, setDatas ] = useState([])
  const [total, setTotal] = useState(null)
  // const [riders, setRiders] = useState(null)
  // const [drivers, setDrivers] = useState(null)
  // const [rides, setRides] = useState(null)
  // const [deliveries, setDeliveries] = useState(null)
  

  let data;

  switch(type){
    case "users":
      data={
        title:"ALL USERS",
        isMoney:false,
        link:"see all customers",
        page:"/customers",
        amount: users,
        icon:<
          PeopleIcon className="icon" 
          style={{
          color:"crimson",
          backgroundColor: "rgba(255, 0, 0, 0.2)"
        }}/>,
      }
       break;
       case "subscribers":
        data={
          title:"ALL SUBSCRIBERS",
          isMoney:false,
          link:"see all subscribers",
          page:"/subscribers",
          amount: subscribers,
          icon:<
            GroupsIcon className="icon" 
            style={{
            color:"crimson",
            backgroundColor: "rgba(255, 0, 0, 0.2)"
          }}/>,
        }

        break;
      
        case "outlets":
          data={
            title:"ALL OUTLETS",
            isMoney:false,
            link:"view all outlet",
            page:"/outlets",
            amount: outlets ,
            icon:<OutletIcon className="icon"
            style={{
              color:"green",
              backgroundColor: "rgba(0, 128, 0, 0.2)"
            }}/>,
          }

        break;
      
      // case "earnings":
      //   data={
      //     title:"ALL EARNINGS",
      //     isMoney:true,
      //     link:"view earnings",
      //     page:"/payments",
      //     amount: earnings ,
      //     icon:<MonetizationOnOutlinedIcon className="icon"
      //     style={{
      //       color:"green",
      //       backgroundColor: "rgba(128, 0, 128, 0.2)"
      //     }}/>,
      //   }
      //   break;
        
      case "adverts":
        data={
          title:"ALL ADVERTS",
          isMoney:false,
          link:"see details",
          page:"/adverts",
          amount: adverts,
          icon:<InterestsIcon className="icon"
          style={{
            color:"purple",
            backgroundColor: "rgba(128, 0, 128, 0.2)"
          }}
          />,
        }
        break;
      default:
      break
  }


  useEffect(() => {
           
        const collectionRef = query(collection(db, "subscribers"), where("status", "==", "active"))
    
        const unsub = onSnapshot(collectionRef, (snapShot) => {

          let list = [];
          
          snapShot.docs.forEach((doc) => {
            list.push({amount:doc.data().amount})
          })
          setDatas(list)
          const earning = list.reduce((tot, currentValue) => tot = tot + currentValue.amount, 0);
          const options = {  maximumFractionDigits: 2   }   
          const formattedNumber = Intl.NumberFormat("en-US",options).format(earning); 
          setEarnings(formattedNumber)
          }, 
            (error) => {
              console.log(error)
            }
          );
      
          return () => {
            unsub();
          }
      
    //END LISTEN REAL TIME    
    
  },[])


  useEffect(() => {

    const fetchData = async() => {
      const today = new Date();
      const lastMonth = new Date(new Date().setMonth(today.getMonth() - 1))
      const prevMonth = new Date(new Date().setMonth(today.getMonth() - 2))
      console.log(lastMonth)
      console.log(prevMonth)


    //   const todayQuery = query(
    //   collection(db, "subscribers"), 
    //   where("timeStamp", "==", today)
    // );

    //   const todayData = await getDocs(todayQuery)
    //   setSubscribers(subscribersData.docs.length)

      // const lastMonthQuery = query(
      //   collection(db, "rides"), 
      //   where("timeStamp", "<=", today),
      //   where("timeStamp", ">", lastMonth)
      // );
      // const prevMonthQuery = query(
      //   collection(db, "rides"), 
      //   where("timeStamp", "<=", lastMonth),
      //   where("timeStamp", ">", prevMonth)
      // );
      

      // db.collection("users")
      // .onSnapshot((snapshot) => {
      //     // ...
      // }, (error) => {
      //     // ...
      // });



      const usersQuery = collection(db, "users")
      const allUsers = await getDocs(usersQuery)
      setUsers(allUsers.docs.length)



      const outletsQuery = collection(db, "subscribers")
      const allOutlets = await getDocs(outletsQuery)
      setOutlets(allOutlets.docs.length)


      const advertQuery = collection(db, "adverts")
      const allAdverts = await getDocs(advertQuery)
      setAdverts(allAdverts.docs.length)



      const subscribersQuery = query(
        collection(db, "users"), 
        where("subscribed", "==", true),
      );
      const subscribersData = await getDocs(subscribersQuery)
      setSubscribers(subscribersData.docs.length)

    
    };

    fetchData();

  }, [])

  return (
    <div className='widget'>
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter" to>
          {data.isMoney && 'N'}
          {data.amount}
        </span>
         <Link to={data.page} className='page'>
        <span className="link">{data.link}</span>
        </Link> 
      </div>
      <div className="right">
        <div className="percentage positive">
          <KeyboardArrowUpOutlinedIcon/>
          {diff}%
        </div>
        {data.icon}
      </div>
    </div>
  )
}

export default Widget